<template>
  <div id="app">
    <TopHeader />
    <loginTan ref="loginTan" />
    <!-- <vipTan ref="vipTan" /> -->
    <router-view />
    <right />
    <Footers />
  </div>
</template>

<script>
// import store from "@/store";
import TopHeader from "@/components/TopHeader.vue";
import loginTan from "@/components/loginTan.vue";
// import vipTan from "@/components/vipTan.vue";
import right from "@/components/right.vue";
import Footers from "@/components/Footer.vue";
import { mapState } from "vuex";
export default {
  name: "App",
  components: {
    TopHeader,
    loginTan,
    // vipTan,
    right,
    Footers,
  },
  beforeCreate() {
    if (sessionStorage.getItem("is_login_again") != 1) {
      console.log('window',window.location);
    }
  },
  computed: {
    ...mapState(["pageTitle", "preRouter"]),
  },
  watch: {
    // '$store.state.pageTitle'(newVal, oldVal) {
    // 	//对数据执行操作
    // 	console.log(newVal, oldVal)
    // },
    // '$store.state.pageFooterType'(newVal, oldVal) {
    // 	//对数据执行操作
    // 	console.log(newVal, oldVal)
    // }
  },
  created() {
    // console.log(store)
  },
  methods: {},
  mounted() {
    //用于判断是否清除cookie（关闭项目重新登录）
    sessionStorage.setItem('is_login_again',1)
  },
};
</script>
<style lang="scss">
@import url("assets/css/common.css");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
</style>
